
import { computed, defineComponent, PropType } from 'vue';
import CMSLinkHandler from '@/shared/content/blocks/helpers/CMSLinkHandler.vue';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';
import { CallToActionTileModel } from '@/types/B2BcontentServerContract';

export default defineComponent({
    name: 'CallToAction5050Layout',
    components: { MediaHandler, CMSLinkHandler },
    props: {
        content: {
            type: Object as PropType<CallToActionTileModel>,
            required: true,
        },
    },
    setup(props) {
        const aspectRatio = { xs: 1 / 1, sm: 4 / 3, md: 5 / 6, default: 10 / 9 };

        const textTileContentBlock = computed(() => {
            return props.content.tiles[0].model;
        });

        const mediaTileContentBlock = computed(() => {
            return props.content.tiles[1].model;
        });

        const flexOrderClass = computed(() => {
            return props.content.flipImageAndText ? 'flex-col md:flex-row' : 'flex-col md:flex-row-reverse';
        });

        return {
            aspectRatio,
            flexOrderClass,
            mediaTileContentBlock,
            textTileContentBlock,
        };
    },
});
